import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';

import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { AiUMCEffects, reducer } from './store';
import { AI_UMC } from './constant';

@NgModule({
  imports: [
    StoreModule.forFeature(AI_UMC, reducer),
    EffectsModule.forFeature([AiUMCEffects]),
  ],
  declarations: [],
  exports: [],
  providers: [],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class AIUMCModule {}
